// @ts-nocheck

import palette from '../palette';

export const CatalogFilters = {
  color: palette.white,
  primaryBackground: palette.bluegrey900,
  secondaryBackground: palette.bluegrey900,
  closeSvgColor: palette.white,
};
